export const leadersDirectoryPageUrl = '/leaders';
export const leadersDirectoryConnectedPageUrl = '/leaders/connected';
export const leadersDirectoryFollowedPageUrl = '/leaders/followed';
export const leadersDirectoryAllPageUrl = '/leaders/all';
